(() => {
  const reviewerNameSelector = [
    '.jdgm-rev__author',
    '.jdgm-all-reviews-page__reviewer-name',
    '.jdgm-carousel-item__reviewer-name',
    '.jdgm-gallery-popup__reviewer-name',
  ].join(',');

  const anonymizeReviewerName = (element) => {
    const fullName = element.textContent.trim();
    const nameParts = fullName.split(/\s+/).filter(Boolean);

    if (nameParts.length < 2) return;

    const firstName = nameParts[0];
    const lastInitial = nameParts[nameParts.length - 1].charAt(0).toUpperCase();
    const anonymizedName = `${firstName} ${lastInitial}.`;

    if (fullName !== anonymizedName) {
      element.textContent = anonymizedName;
    }
  };

  const anonymizeReviewerNames = (root) => {
    if (root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_NODE) return;

    if (root.nodeType === Node.ELEMENT_NODE && root.matches(reviewerNameSelector)) {
      anonymizeReviewerName(root);
    }

    root.querySelectorAll(reviewerNameSelector).forEach(anonymizeReviewerName);
  };

  const startReviewerNamePrivacy = () => {
    anonymizeReviewerNames(document);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'characterData') {
          const parent = mutation.target.parentElement;
          if (parent && parent.matches(reviewerNameSelector)) anonymizeReviewerName(parent);
          return;
        }

        mutation.addedNodes.forEach((node) => anonymizeReviewerNames(node));
      });
    });

    observer.observe(document.body, {
      childList: true,
      characterData: true,
      subtree: true,
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startReviewerNamePrivacy, { once: true });
  } else {
    startReviewerNamePrivacy();
  }
})();
